import { jwtDecode } from 'jwt-decode';

export const Auth = {
  getToken: () => localStorage.getItem("nimda_giwasco"),

  setToken: (token) =>
    localStorage.setItem("nimda_giwasco", token),

  clearToken: () =>
    localStorage.removeItem("nimda_giwasco"),

  isAuthenticated: () => {
    const token = localStorage.getItem("nimda_giwasco");
    if (!token) return false;

    try {
      const decoded = jwtDecode(token);
      return Date.now() < decoded.exp * 1000;
    } catch {
      return false;
    }
  },
};